import React from "react";
import { GlobalTableActionButton } from "../../global/GlobalTableActionButton";
import { resolveMediaUrl } from "../../utils/resolveMediaUrl";

/**
 * Icon button that opens a payment receipt/proof URL in a new tab.
 * Renders an em dash when no proof is available.
 */
export default function PaymentProofViewButton({
  proofUrl,
  title = "View payment proof",
}) {
  const url = resolveMediaUrl(proofUrl);
  if (!url) return "—";

  return (
    <div className="ub-table-actions">
      <GlobalTableActionButton
        action="receipt"
        title={title}
        ariaLabel={title}
        onClick={() => {
          window.open(url, "_blank", "noopener,noreferrer");
        }}
      />
    </div>
  );
}
